"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.find-index.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _interface = require("../interface");
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../../_utils/hooks/usePrefixCls");
var _excluded = ["size", "color", "className", "style"]; // GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
/* eslint-disable */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var RefreshIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('icon');
  var size = props.size,
    color = props.color,
    className = props.className,
    customStyle = props.style,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var isFontSize = false;
  var isSize = false;
  if (typeof size === 'number') {
    isFontSize = true;
  } else {
    isSize = _interface.SizeTypes.findIndex(function (item) {
      return item === size;
    }) !== -1;
  }
  var classes = (0, _classnames.default)(prefixCls, prefixCls + '--' + 'refresh', (0, _defineProperty2.default)({}, 'size-' + size, isSize), className);
  var style = _objectSpread({
    color: color,
    fontSize: isFontSize ? size : undefined
  }, customStyle);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    ref: ref,
    className: classes,
    style: style
  }, restProps, {
    height: "16px",
    width: "16px",
    version: "1.1",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("title", null, "refresh"), /*#__PURE__*/_react.default.createElement("g", {
    id: "refresh",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    height: "16",
    id: "\u77E9\u5F62",
    width: "16",
    x: "0",
    y: "0"
  }), /*#__PURE__*/_react.default.createElement("g", {
    id: "\u5206\u7EC4",
    fill: "currentColor",
    transform: "translate(2.000000, -1.000000)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    id: "\u5F62\u72B6\u7ED3\u5408",
    d: "M5.5,3.46446609 C6.42871874,3.46446609 7.30367433,3.69465347 8.07092607,4.10108752 L6.54776407,5.62399546 C6.21694955,5.52033786 5.86499955,5.46446609 5.5,5.46446609 C3.56700338,5.46446609 2,7.03146947 2,8.96446609 C2,9.32946565 2.05587177,9.68141565 2.15952936,10.0122302 L0.636621425,11.5353922 C0.230187381,10.7681404 0,9.89318483 0,8.96446609 C0,5.92689997 2.46243388,3.46446609 5.5,3.46446609 Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "\u5F62\u72B6\u7ED3\u5408",
    d: "M9.42936204,6.39382813 C10.3580808,6.39382813 11.2330364,6.62401551 12.0002881,7.03044956 L10.4771261,8.5533575 C10.1463116,8.4496999 9.79436159,8.39382813 9.42936204,8.39382813 C7.49636541,8.39382813 5.92936204,9.96083151 5.92936204,11.8938281 C5.92936204,12.2588277 5.98523381,12.6107777 6.0888914,12.9415922 L4.56598346,14.4647542 C4.15954942,13.6975025 3.92936204,12.8225469 3.92936204,11.8938281 C3.92936204,8.85626201 6.39179591,6.39382813 9.42936204,6.39382813 Z",
    fillRule: "nonzero",
    transform: "translate(7.964681, 10.429147) rotate(-180.000000) translate(-7.964681, -10.429147) "
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    id: "\u77E9\u5F62",
    points: "3.53553391 2 8.53553391 2 8.53553391 7",
    transform: "translate(6.035534, 4.500000) rotate(-315.000000) translate(-6.035534, -4.500000) "
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    id: "\u77E9\u5F62",
    points: "3.53553391 11 8.53553391 11 8.53553391 16",
    transform: "translate(6.035534, 13.500000) scale(-1, 1) rotate(-315.000000) translate(-6.035534, -13.500000) "
  }))));
});
var _default = exports.default = RefreshIcon;